module.exports = __webpack_public_path__ + "img/line-black.f665e799.svg";